import type {ColDef} from "ag-grid-community";
import AbsAGGridEditViewColumn from "@/utils/UIConstants/AGGridEditViewColumns/AbsAGGridEditViewColumn.ts";
import EditableGridHandler from "@/utils/presenters/EditableGridHandler.ts";
import AGGridAttachmentCellRenderer from "@/components/inputs/AGGridAttachmentCellRenderer.vue";
import EditScreenGridColumn = namaTypes.EditScreenGridColumn;

export default class AGGridEditViewAttachmentColumn extends AbsAGGridEditViewColumn {
  constructor(column: EditScreenGridColumn, handler: EditableGridHandler) {
    super(column, handler);
  }

  override createColDef(): ColDef[] {
    let colDef = AbsAGGridEditViewColumn.defaultColDef(this);
    colDef.cellRenderer = AGGridAttachmentCellRenderer
    colDef.editable = false;
    colDef.cellRendererParams = {
      handler: () => this.handler,
      columnId: this.id,
      columnMetadata: this.columnMetadata,
    }
    return [colDef];
  }
}
